/* eslint-disable no-underscore-dangle */
/** @typedef {import('../models/photo-entity').default} PhotoEntity */
/** @typedef {import('../models/author-entity').default} AuthorEntity */

import {
  PHOTO_AUTHOR,
  PHOTO_AUTHOR_LINK,
  PHOTO_AUTHOR_NAME,
  PHOTO_AUTHOR_PHOTOS_NUM,
} from "../constants"

const AUTHOR_LINK_CLASSNAME = "gallery-photo-description__link"

class AuthorElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof AuthorElement
   */
  static fromHtmlElement(htmlElement) {
    const rootElement = htmlElement.querySelector(PHOTO_AUTHOR)
    const linkElement = htmlElement.querySelector(PHOTO_AUTHOR_LINK)
    const nameElement = htmlElement.querySelector(PHOTO_AUTHOR_NAME)
    const photosNumElement = htmlElement.querySelector(PHOTO_AUTHOR_PHOTOS_NUM)

    return new AuthorElement({
      rootElement,
      linkElement,
      nameElement,
      photosNumElement,
    })
  }

  /**
   * Creates an instance of AuthorElement.
   * @param {Object} settings
   * @param {HTMLElement} settings.rootElement
   * @param {HTMLElement} settings.linkElement
   * @param {HTMLElement} settings.nameElement
   * @param {HTMLElement} settings.photosNumElement
   * @memberof AuthorElement
   */
  constructor({ rootElement, linkElement, nameElement, photosNumElement }) {
    this.rootElement = rootElement
    this.linkElement = linkElement
    this.nameElement = nameElement
    this.photosNumElement = photosNumElement
  }

  /**
   * @param {PhotoEntity} photo
   * @memberof AuthorElement
   */
  apply(photo) {
    const { author } = photo

    if (author.name === null) {
      this.rootElement.classList.add("is-hidden")
      return
    }

    if (author.name !== null && author.url === null) {
      this.rootElement.classList.remove("is-hidden")

      if (this.linkElement !== null) {
        this.linkElement.remove()
        this.linkElement = null
        this.photosNumElement = null
      }

      this._createAndUpdateNameElement(author)
      this.rootElement.appendChild(this.nameElement)
      return
    }

    if (author.name !== null && author.url !== null) {
      this.rootElement.classList.remove("is-hidden")

      this._createAndUpdateNameElement(author)
      this._createAndUpdateLinkElement(author)
      this._createAndUpdatePhotosNumElement(author)

      this.linkElement.appendChild(this.nameElement)
      this.linkElement.appendChild(this.photosNumElement)
      this.rootElement.appendChild(this.linkElement)
    }
  }

  /**
   * @param {AuthorEntity} author
   * @memberof AuthorElement
   */
  _createAndUpdateNameElement(author) {
    if (!this.nameElement !== null) {
      this.nameElement.remove()
      this.nameElement = null
    }

    this.nameElement = document.createElement("span")
    this.nameElement.appendChild(document.createTextNode(author.name))
  }

  /**
   * @param {AuthorEntity} author
   * @memberof AuthorElement
   */
  _createAndUpdateLinkElement(author) {
    if (this.linkElement !== null) {
      this.linkElement.remove()
      this.linkElement = null
    }

    this.linkElement = document.createElement("a")
    this.linkElement.setAttribute("href", author.url)
    this.linkElement.classList.add(AUTHOR_LINK_CLASSNAME)
  }

  /**
   * @param {AuthorEntity} author
   * @memberof AuthorElement
   */
  _createAndUpdatePhotosNumElement(author) {
    if (this.photosNumElement !== null) {
      this.photosNumElement.remove()
      this.photosNumElement = null
    }

    this.photosNumElement = document.createElement("span")
    this.photosNumElement.appendChild(document.createTextNode(` (${author.photosNum} photos)`))
  }
}
export default AuthorElement
